import React from 'react';
import './Trigger.less';

export const Trigger = ({children, onClick}) => {
	return (
		<button className={`trigger ${onClick ? 'trigger--clickable' : ''}`} onClick={onClick}>
			{children}
		</button>
	);
};
